import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { Conceptos } from '@p-p-portafolio/interfaces/conceptos';
import { SwalService } from '@shared/utils/swal.service';
import { ConceptosService } from '@p-p-portafolio/services/conceptos.service';
import Swal from 'sweetalert2';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-conceptos',
  templateUrl: './conceptos.component.html',
  providers: [MessageService]
})
export class ConceptosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedConcepto: Conceptos | null = null;
  dataSource: Conceptos[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns: Column[] = [
    { field: 'concepto', header: 'Clave Concepto' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'aplicaPagoMinimo', header: 'Aplica Pago Mínimo' },
    { field: 'aplicaSaldoPromedio', header: 'Aplica Saldo Promedio' },
    { field: 'integraConsumo', header: 'Integra Consumo' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private messageService: MessageService,
    private conceptosService: ConceptosService,
    private swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    this.conceptosService.getConceptosList().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los conceptos'
          });
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar conceptos:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los conceptos'
        });
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedConcepto = null;
    this.displayDialog = true;
  }

  openUpdate(row: Conceptos): void {
    this.selectedConcepto = { ...row };
    this.displayDialog = true;
  }

  onDialogClosed(): void {
    this.selectedConcepto = null;
    this.displayDialog = false;
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.read();
  }

  isConceptoPrincipal(concepto: number): boolean {
    return concepto >= 1 && concepto <= 4;
  }

  openDelete(model: Conceptos) {
    if (this.isConceptoPrincipal(model.concepto)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Advertencia',
        detail: 'No se puede eliminar un concepto principal (1, 2, 3 o 4)'
      });
      return;
    }

    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el concepto ${model.concepto}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.conceptosService.delete(model).subscribe({
          next: (response) => {
            if (response.success && response.data) {
              this.swalService.success('Eliminado correctamente');
              this.read();
            } else {
              this.swalService.error('Error al eliminar el concepto');
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this.swalService.error('Error al eliminar');
            this.loading = false;
          }
        });
      }
    });
  }
}
